import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { AuthProvider } from '../../context/auth';
import classnames from 'classnames';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { isMobile } from 'react-device-detect';
import isEmpty from '../../validation/is-empty';

import AuthRoute from './util/AuthRoute';
import PrivateRoute from './util/PrivateRoute';

import 'react-confirm-alert/src/react-confirm-alert.css';
import './Amazon.scss';
import { ShipmentLoadUsers } from '../../util/ShipmentLoadUsers';

const Navbar = lazy(() => import('./navbar/Navbar'));
const OnboardingList = lazy(() => import('./onboarding-list'));
const Sandbox = lazy(() => import('./sandbox'));

// ** VERSION 1 **
// import OnboardingOld from './onboarding/Onboarding';
// const Login = lazy(() => import('./auth/login/Login'));
// const Onboarding = lazy(() => import('../onboarding/Onboarding'));

// **** Version 2 ****
const LoginV2 = lazy(() => import('./login-v2/LoginV2'));
const PartnersV2 = lazy(() => import('./partners-v2/PartnersV2'));
const NotFoundV2 = lazy(() => import('../not-found-v2/NotFoundV2'));
const OnboardingV2 = lazy(() => import('../onboarding-v2/OnboardingV2'));
const TranslateCfdi = lazy(() => import('./translate-cfdi/TranslateCfdi'));
const TranslatePortCart = lazy(
  () => import('./translat-cart/TranslatePortCart'),
);

function Amazon() {
  const [showNavbar, setShowNavbar] = useState(true);
  const { pathname } = useLocation();
  const history = useHistory();
  const [isTranslateUser, setIsTranslateUser] = useState(false);

  useEffect(() => {
    if (isEmpty(localStorage.getItem('jwtToken'))) {
      return;
    }
    setTimeout(() => {
      let dateStorage = localStorage.getItem('date');
      // si la fecha es mayor a 8 horas, se limpia el localstorage
      if (dateStorage) {
        let date = new Date(dateStorage);
        let dateNow = new Date();
        let diff = (dateNow - date) / 1000;
        diff /= 60 * 60;
        if (Math.abs(Math.round(diff)) > 8) {
          localStorage.clear();
          window.location.reload();
        } else {
          // setTimeout(() => {
          let userStorage = localStorage.getItem('user');

          if (ShipmentLoadUsers.includes(userStorage)) {
            if (pathname === '/dsp/translate-port-cart') return;
            history.push('/dsp/translate-cfdi');
            setShowNavbar(true);
            setIsTranslateUser(true);
          } else {
            if (
              ['/onboardings', '/ihs/onboarding', '/dsp/onboarding'].includes(
                pathname,
              )
            ) {
              setShowNavbar(false);
            } else setShowNavbar(true);
          }
          // }, 1000);
        }
      }
    }, 1000);
  }, [pathname]);

  return (
    <div
      className={classnames('Amazon', {
        withNavbar: showNavbar && !isEmpty(localStorage.getItem('jwtToken')),
      })}
    >
      <HelmetProvider>
        <Helmet>{isMobile && <body class="mobile" />}</Helmet>
        <ReactNotification />
        <main className="content-wrap">
          <AuthProvider>
            <Suspense fallback={null}>
              {showNavbar && (
                <Navbar showNavbar={showNavbar} viewOptions={isTranslateUser} />
              )}
              <Switch>
                {/* ** VERSION Beta (rechazada) **
                <Route exact path="/onboarding/:token/" component={OnboardingOld}/>
                */}

                {/* ** VERSION 1 **
                <AuthRoute exact path="/" component={Login} />
                <Route exact path="/onboardings" component={Onboarding} />
                <PrivateRoute exact path="/partners" component={PartnersV2} />
                <PrivateRoute exact path="/sandbox" component={Sandbox} />
                <PrivateRoute
                  exact
                  path="/onboardings/status"
                  component={OnboardingList}
                />
              */}

                {/** ** VERSION 2 **  */}
                <AuthRoute exact path="/:slug" component={LoginV2} />
                <Route
                  exact
                  path="/:code/onboarding"
                  component={OnboardingV2}
                />
                <PrivateRoute
                  exact
                  path="/:slug/translate-cfdi"
                  component={TranslateCfdi}
                />
                <PrivateRoute
                  exact
                  path="/:slug/translate-port-cart"
                  component={TranslatePortCart}
                />
                <PrivateRoute
                  exact
                  path="/:slug/partners"
                  component={PartnersV2}
                />
                <PrivateRoute
                  exact
                  path="/:slug/onboardings/status"
                  component={OnboardingList}
                />
                <PrivateRoute exact path="/:slug/sandbox" component={Sandbox} />
                <Route
                  component={() => (
                    <NotFoundV2
                      setShowNavbar={setShowNavbar}
                      showHelpLinks={false}
                    />
                  )}
                />
              </Switch>
            </Suspense>
          </AuthProvider>
        </main>
      </HelmetProvider>
    </div>
  );
}

export default Amazon;
